import type { CompanyThemeConfig, Theme } from "@/types/Theme";

const BASE_TITLE = "Quickersim";
const BASE_FAVICON = "/favicon.ico";

export const COMPANY_CONFIG: Record<Theme, CompanyThemeConfig> = {
  default: {
    title: BASE_TITLE,
    favicon: BASE_FAVICON,
  },
  vtac: {
    title: "V-TAC",
    favicon: "/vtac-favicon.ico",
  },
};
